// extracted by mini-css-extract-plugin
module.exports = {"input":"TemplateInput_input__YywFB"};